import { createUseStyles } from 'react-jss';
import { GrayscalePalette, SecondaryBluePalette } from '@tcl-boron-colors/colors';

const toMaskUrl = (svg: string) => `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;

const TRIALS_ICON_MASK = toMaskUrl(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z"/><path d="M14 8H22V10H14z"/><path d="M14 15H22V17H14z"/><path d="M14 22H22V24H14z"/></svg>',
);

const CARE_PATHWAYS_ICON_MASK = toMaskUrl(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14.2857 5.71431C14.2857 4.45396 13.2606 3.42858 12 3.42858C10.7394 3.42858 9.71426 4.45396 9.71426 5.71431C9.71426 6.77625 10.4454 7.6634 11.4286 7.91889V8.57146C11.4286 8.88649 11.1724 9.14289 10.8571 9.14289H5.14282C4.9415 9.14289 4.75099 9.1842 4.57139 9.24821V4.4903C5.55453 4.23481 6.28568 3.34767 6.28568 2.28572C6.28568 1.02538 5.26059 0 3.99996 0C2.73932 0 1.71423 1.02538 1.71423 2.28572C1.71423 3.34767 2.44538 4.23481 3.42853 4.4903V11.5097C2.44538 11.7652 1.71423 12.6523 1.71423 13.7143C1.71423 14.9746 2.73932 16 3.99996 16C5.26059 16 6.28568 14.9746 6.28568 13.7143C6.28568 12.6523 5.55453 11.7652 4.57139 11.5097V10.8571C4.57139 10.5421 4.8275 10.2857 5.14282 10.2857H10.8571C11.8024 10.2857 12.5714 9.51672 12.5714 8.5714V7.91883C13.5546 7.66334 14.2857 6.77625 14.2857 5.71431ZM5.14282 13.7143C5.14282 14.3446 4.62996 14.8572 3.99996 14.8572C3.36995 14.8572 2.85709 14.3446 2.85709 13.7143C2.85709 13.084 3.36995 12.5715 3.99996 12.5715C4.62996 12.5715 5.14282 13.084 5.14282 13.7143ZM2.85709 2.28572C2.85709 1.65543 3.36995 1.14286 3.99996 1.14286C4.62996 1.14286 5.14282 1.65543 5.14282 2.28572C5.14282 2.91601 4.62996 3.42858 3.99996 3.42858C3.36995 3.42858 2.85709 2.91601 2.85709 2.28572ZM12 6.85717C11.37 6.85717 10.8571 6.34459 10.8571 5.71431C10.8571 5.08402 11.37 4.57144 12 4.57144C12.63 4.57144 13.1428 5.08402 13.1428 5.71431C13.1428 6.34459 12.63 6.85717 12 6.85717Z" /></svg>',
);

const MATCH_REVIEW_ICON_MASK = toMaskUrl(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 20.415 25.586 19 23 21.587 20.414 19 19 20.415 21.586 23 19 25.586 20.414 27 23 24.414 25.586 27 27 25.586 24.414 23 27 20.415z"/><path d="M24,4a4.0045,4.0045,0,0,0-4,4,3.951,3.951,0,0,0,.5669,2.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"/><path d="M8 11.18 5.41 8.59 4 10 8 14 15 7 13.59 5.59 8 11.18z"/></svg>',
);

const REPORTING_ICON_MASK = toMaskUrl(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28 22H30V30H28z"/><path d="M24 18H26V30H24z"/><path d="M20 26H22V30H20z"/><path d="M9,16a7,7,0,1,0,7,7A7.0078,7.0078,0,0,0,9,16Zm4.8989,6H10V18.1011A5.0145,5.0145,0,0,1,13.8989,22ZM9,28a5,5,0,0,1-1-9.8989V22a2,2,0,0,0,2,2h3.8989A5.0081,5.0081,0,0,1,9,28Z"/><path d="M22.5352,12l4-6H30V4H25.4648l-4,6H18V2H16V14a2,2,0,0,0,2,2H30V14H18V12Z"/><circle cx="11" cy="7" r="1"/><circle cx="9" cy="11" r="1"/><circle cx="7" cy="5" r="1"/><circle cx="5" cy="9" r="1"/><circle cx="3" cy="13" r="1"/></svg>',
);

const HOSPITAL_ICON_MASK = toMaskUrl(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21 10 17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"/><path d="M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"/></svg>',
);

const ICON_MASK_STYLES = {
  content: '""',
  width: 14,
  height: 14,
  flexShrink: 0,
  backgroundColor: 'currentColor',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
} as const;

const NAV_TOP_GAP_BUTTON_LABELS = [
  'Trials',
  'Trial Match Review',
  'Reporting',
  'Sites',
  'My Sites',
  'All Patients',
  'Trials Pre-screening',
  'Pathways Pre-screening',
  'Tempus Nurse',
  'Cohort Builder',
  'Next Prescreening',
  'TIME Prescreening',
] as const;

const navTopGapButtonsSelector = NAV_TOP_GAP_BUTTON_LABELS.map(
  (label) => `& [data-analytics="navigation-top"] button[aria-label="${label}"]`,
).join(', ');

export const useStyles = createUseStyles({
  root: {
    backgroundColor: GrayscalePalette['100'],
    boxShadow: `0px 1px 3px 1px ${GrayscalePalette[400]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // Stack above `App`’s main shell (`z-index: 0`) so shadow and in-DOM menus stay visible/clickable.
    position: 'relative',
    zIndex: 2,
  },
  navbar: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    height: 72,
    maxWidth: 1216,
  },
  appSwitcherContainer: {
    alignItems: 'center',
    backgroundColor: GrayscalePalette['100'],
    display: 'flex',
    padding: '0 8px',
    '& button[class*="appSwitcherButton"]': {
      backgroundColor: `${GrayscalePalette['100']} !important`,
      border: 'none',
      borderRadius: 8,
      color: `${GrayscalePalette[700]} !important`,
      height: 48,
      minWidth: 32,
      padding: 0,
      transition: 'background-color 120ms ease',
      '--tcl-icon-button-color': GrayscalePalette[700],
    },
    '& button[class*="appSwitcherButton"][style*="--tcl-icon-button-background-color"]:not([style*="--tcl-icon-button-background-color: transparent"])':
      {
        backgroundColor: `${SecondaryBluePalette[100]} !important`,
        borderColor: `${SecondaryBluePalette[100]} !important`,
      },
    '& button[class*="appSwitcherButton"]:hover': {
      backgroundColor: `${SecondaryBluePalette[300]} !important`,
      borderColor: `${SecondaryBluePalette[300]} !important`,
    },
    '& button[class*="appSwitcherButton"]:active': {
      backgroundColor: `${SecondaryBluePalette[200]} !important`,
      borderColor: `${SecondaryBluePalette[200]} !important`,
    },
  },
  logo: {
    flexShrink: 0,
    padding: '0 16px',
    '@media (max-width: 1279px)': {
      padding: '0 12px',
    },
    '@media (max-width: 1099px)': {
      padding: '0 10px',
    },
  },
  navTopOverrides: {
    flex: 1,
    '& [data-analytics="navigation-top"]': {
      boxShadow: 'none',
    },
    '& [data-analytics="navigation-top"] > div:last-child': {
      flex: 1,
      justifyContent: 'flex-start',
    },
    '& [data-analytics="navigation-top"] > div:last-child > div:nth-last-child(2)': {
      marginLeft: 'auto',
    },
    '& [data-analytics="navigation-top"] div[class*="globalSearchRoot"]': {
      display: 'none',
    },
    '& [data-analytics="navigation-top"] [data-analytics="menu"]:has([class*="menuItemsContainer"]) button[data-analytics="button"] [class*="children"] > div:last-of-type svg':
      {
        transform: 'rotate(180deg)',
      },
    '& [data-analytics="navigation-top"] button': {
      border: 'none',
      borderRadius: 8,
      color: GrayscalePalette[650],
      height: 48,
      minWidth: 32,
      padding: '0 16px',
      transition: 'background-color 120ms ease',
    },
    '& [data-analytics="navigation-top"] button[data-analytics="avatar"]': {
      marginRight: 0,
      padding: 0,
    },
    '& [data-analytics="navigation-top"] button[aria-label="help"]': {
      padding: 0,
    },
    '& [data-analytics="navigation-top"] button[data-analytics="avatar"]:hover': {
      backgroundColor: `${SecondaryBluePalette[300]} !important`,
      borderColor: `${SecondaryBluePalette[300]} !important`,
    },
    // Match both spaced and compact inline CSS var serialization (React / browsers vary).
    '& [data-analytics="navigation-top"] button[style*="--tcl-default-background-color:transparent"], & [data-analytics="navigation-top"] button[style*="--tcl-default-background-color: transparent"]':
      {
        backgroundColor: GrayscalePalette['100'],
      },
    '& [data-analytics="navigation-top"] button[style*="--tcl-default-background-color"]:not([style*="--tcl-default-background-color:transparent"]):not([style*="--tcl-default-background-color: transparent"])':
      {
        backgroundColor: SecondaryBluePalette[100],
      },
    '& [data-analytics="navigation-top"] button:is([style*="--tcl-default-background-color:transparent"], [style*="--tcl-default-background-color: transparent"]):hover, & [data-analytics="navigation-top"] button[style*="--tcl-default-background-color"]:not([style*="--tcl-default-background-color:transparent"]):not([style*="--tcl-default-background-color: transparent"]):hover':
      {
        backgroundColor: SecondaryBluePalette[300],
      },
    '& [data-analytics="navigation-top"] button:is([style*="--tcl-default-background-color:transparent"], [style*="--tcl-default-background-color: transparent"]):active, & [data-analytics="navigation-top"] button[style*="--tcl-default-background-color"]:not([style*="--tcl-default-background-color:transparent"]):not([style*="--tcl-default-background-color: transparent"]):active':
      {
        backgroundColor: SecondaryBluePalette[200],
      },
    [navTopGapButtonsSelector]: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Trials"]::before': {
      ...ICON_MASK_STYLES,
      WebkitMaskImage: TRIALS_ICON_MASK,
      maskImage: TRIALS_ICON_MASK,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Care Pathways"]': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Care Pathways"]::before': {
      ...ICON_MASK_STYLES,
      WebkitMaskImage: CARE_PATHWAYS_ICON_MASK,
      maskImage: CARE_PATHWAYS_ICON_MASK,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Trial Match Review"], & [data-analytics="navigation-top"] button[aria-label="Reporting"], & [data-analytics="navigation-top"] button[aria-label="Sites"], & [data-analytics="navigation-top"] button[aria-label="My Sites"], & [data-analytics="navigation-top"] button[aria-label="All Patients"], & [data-analytics="navigation-top"] button[aria-label="Trials Pre-screening"], & [data-analytics="navigation-top"] button[aria-label="Pathways Pre-screening"], & [data-analytics="navigation-top"] button[aria-label="Tempus Nurse"], & [data-analytics="navigation-top"] button[aria-label="Cohort Builder"], & [data-analytics="navigation-top"] button[aria-label="Next Prescreening"], & [data-analytics="navigation-top"] button[aria-label="TIME Prescreening"]':
      {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
      },
    '& [data-analytics="navigation-top"] button[aria-label="Trial Match Review"]::before': {
      ...ICON_MASK_STYLES,
      WebkitMaskImage: MATCH_REVIEW_ICON_MASK,
      maskImage: MATCH_REVIEW_ICON_MASK,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Reporting"]::before': {
      ...ICON_MASK_STYLES,
      WebkitMaskImage: REPORTING_ICON_MASK,
      maskImage: REPORTING_ICON_MASK,
    },
    '& [data-analytics="navigation-top"] button[aria-label="Sites"]::before, & [data-analytics="navigation-top"] button[aria-label="My Sites"]::before':
      {
        ...ICON_MASK_STYLES,
        WebkitMaskImage: HOSPITAL_ICON_MASK,
        maskImage: HOSPITAL_ICON_MASK,
      },
    '& [data-analytics="navigation-top"] button[data-nav-active="true"]': {
      backgroundColor: SecondaryBluePalette[100],
    },
    '& [data-analytics="navigation-top"] button:hover': {
      backgroundColor: SecondaryBluePalette[300],
    },
    '& [data-analytics="navigation-top"] button:active': {
      backgroundColor: SecondaryBluePalette[200],
    },
    '@media (max-width: 1279px)': {
      '& [data-analytics="navigation-top"] button': {
        padding: '0 12px',
      },
    },
    '@media (max-width: 1099px)': {
      '& [data-analytics="navigation-top"] button::before': {
        display: 'none',
      },
      '& [data-analytics="navigation-top"] button': {
        padding: '0 10px',
      },
      [navTopGapButtonsSelector]: {
        gap: 6,
      },
    },
    '@media (max-width: 899px)': {
      '& [data-analytics="navigation-top"] button': {
        padding: '0 8px',
      },
    },
    '@media (max-width: 767px)': {
      '& [data-analytics="navigation-top"] button': {
        padding: '0 6px',
      },
    },
    /** Embedded `NavigationTop` logo: room after divider before nav (global search is hidden here). */
    '@media (max-width: 999px)': {
      '& [data-analytics="navigation-top"] div[class*="logoContainer"]': {
        marginRight: 8,
      },
    },
  },
});
